import { Checkbox, CircularProgress } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useEnableEcasDownloadMutation } from "../../../services/bl-import/BLImportService";
import { BLImport } from "../../../interfaces/bl-import/blImport.interface";
import { useAppSelector } from "../../../store/hooks";

interface props {
  bl: BLImport;
  disabled?: boolean;
  callback: () => void;
}

export default function EnableEcasCheckbox({ bl, disabled, callback }: props) {
  const { userInfo } = useAppSelector((state) => state.auth);
  const [isEnable, setEnable] = useState(
    bl.puede_descargar_ecas === true ? true : false
  );

  const snack = useSnackbar();

  const [enableEcas, { isSuccess, isError, isLoading, reset }] =
    useEnableEcasDownloadMutation();

  const sendRequest = () => {
    enableEcas({
      id_bl: bl.id!,
      id_usuario: Number(userInfo?.id!),
    });
  };

  const showSuccessSnack = useCallback(() => {
    snack.enqueueSnackbar({
      anchorOrigin: { horizontal: "right", vertical: "bottom" },
      autoHideDuration: 4000,
      variant: "success",
      message: `Se habilito el Ecas del BL - ${bl.hbl}`,
    });
  }, [snack, bl.hbl]);

  const showErrorSnack = useCallback(() => {
    snack.enqueueSnackbar({
      anchorOrigin: { horizontal: "right", vertical: "bottom" },
      autoHideDuration: 2000,
      variant: "error",
      message: "No se pudo habilitar el Ecas. Intente luego.",
    });
  }, [snack]);

  useEffect(() => {
    if (isError === true) {
      showErrorSnack();
      reset();
    }
    return;
  }, [isError, showErrorSnack, reset]);

  useEffect(() => {
    if (isSuccess === true) {
      showSuccessSnack();
      reset();
      callback();
      setEnable(true);
    }
    return;
  }, [isSuccess, showSuccessSnack, reset, callback]);

  if (isLoading === true) {
    return (
      <>
        <CircularProgress size={24} thickness={4} />
      </>
    );
  }

  return (
    <>
      <Checkbox
        disabled={disabled}
        color="primary"
        checked={isEnable}
        onChange={(_, val) => {
          if (val === false) return;
          sendRequest();
        }}
      />
    </>
  );
}
